var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCPlusPlusSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.593 41.008c.251-.435.407-.925.407-1.365V24.367c0-.44-.156-.93-.407-1.364L32 32.005l15.593 9.003z",
    fill: "#00599C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m33.386 49.68 13.228-7.637c.381-.22.728-.6.979-1.035L32 32.005l-15.593 9.003c.251.435.598.815.979 1.035l13.228 7.637c.762.44 2.01.44 2.772 0z",
    fill: "#004482"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.593 23.003c-.251-.436-.598-.815-.979-1.035L33.386 14.33c-.762-.44-2.01-.44-2.772 0l-13.228 7.638c-.762.44-1.386 1.52-1.386 2.4v15.275c0 .44.156.93.407 1.365L32 32.005l15.593-9.002z",
    fill: "#659AD2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42.672c-5.882 0-10.667-4.785-10.667-10.667S26.118 21.338 32 21.338c3.795 0 7.335 2.043 9.237 5.33l-4.616 2.672A5.356 5.356 0 0 0 32 26.672a5.34 5.34 0 0 0-5.333 5.333A5.34 5.34 0 0 0 32 37.34a5.356 5.356 0 0 0 4.621-2.669l4.616 2.671A10.705 10.705 0 0 1 32 42.671z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.667 31.413H41.48v-1.186h-1.185v1.186h-1.185v1.185h1.185v1.185h1.185v-1.185h1.186v-1.185zM47.111 31.413h-1.185v-1.186H44.74v1.186h-1.185v1.185h1.185v1.185h1.185v-1.185h1.185v-1.185z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCPlusPlusSvgrepoCom);
export default __webpack_public_path__ + "static/media/c-plus-plus-svgrepo-com.e442cf22cf76a0077c97229a9d4b5b24.svg";
export { ForwardRef as ReactComponent };